<template>
  <div class="recordList">
    <el-row>
      <el-col :span="2" class="tit">调整类型：</el-col>
      <el-col :span="21">
        <el-checkbox-group v-model="checktypeList" class="checkBoxcom" @change="search">
          <el-col :span="3">
            <el-checkbox label="10">库存调整</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox label="9">库存盘点</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox label="5">退货入库</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox label="4">订单销售</el-checkbox>
          </el-col>        
          <el-col :span="3" v-if="serviceRow.serviceType == 2">
            <el-checkbox label="11">套盒拆分</el-checkbox>
          </el-col>
          <el-col :span="3" v-if="serviceRow.serviceType == 2 || serviceRow.serviceType == 10">
            <el-checkbox label="12">商品入库</el-checkbox>
          </el-col>    
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row style="margin:30px 0;">
      <el-col :span="2" class="tit">时间：</el-col>
      <el-col :span="21" class="stockTime">
        <el-date-picker v-model="stockTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 260px;margin-right: 10px" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" ></el-date-picker>
        <el-button class="searchBtn" @click="search"></el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" ref="multipleTable" class="myMemTable" style="width: 100%" border :header-cell-style="{background:'#EFF1F5'}">
      <el-table-column align="center" prop="createTime" label="时间" width="160"></el-table-column>
      <el-table-column align="center" prop="staffName" label="操作人"></el-table-column>
      <el-table-column align="center" prop="operateType" label="操作类型">
        <template slot-scope="scope">
          {{scope.row.operateType | operateTypeFilter}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="stockType" label="库存">
        <template slot-scope="scope">
          {{scope.row.stockType | stockTypeFilter}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="changeType" label="出入库">
        <template slot-scope="scope">
          {{scope.row.changeType == 1?'出库':'入库'}}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="changeCount" label="变动数量"></el-table-column>
      <el-table-column align="center" prop="originalCount" label="原有库存"></el-table-column>
      <el-table-column align="center" prop="nowCount" label="现有库存"></el-table-column>
      <el-table-column align="center" prop="remarks" label="原因">
        <template slot-scope="scope">
          <el-row class="tableGoods">
            <el-popover trigger="hover" placement="top">
              {{scope.row.remarks}}
              <el-col slot="reference" class="myTitle">
                <span>{{scope.row.remarks | filterRow}}</span>
              </el-col>
            </el-popover>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 20px;text-align:right"
    ></el-pagination>
    <el-row class="btnOptions">
      <el-button class="darkBtn" @click="closeTab">关闭</el-button>
    </el-row>
  </div>
</template>
<script>
import {adjStockDetail} from '@/api'
export default {
  props: ['serviceRow','dialogRecordVisible'],
  data() {
    return {
      checktypeList: ["4", "5", "9","10","11","12"],
      stockTime:[],
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
    };
  },
  watch: {
    'dialogRecordVisible'(val){
      if(val){
        this.checktypeList = this.$options.data().checktypeList;
        this.search()
      }
    }
  },
  created () {
    this.search()
  },
  methods: {
    closeTab() {
      this.$emit("closeDialog", false);
    },
    search(){      
      let postData = {
        operateTypes:this.checktypeList,
        productNo: this.serviceRow.serviceCode,
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        startDate:this.stockTime?this.stockTime[0]:'',
        endDate:this.stockTime?this.stockTime[1]:'',
        serviceType:this.serviceRow.serviceType,
      }
      adjStockDetail(postData).then(res => {
        if(res.code == 1){
          this.total = res.data.total;
          this.tableData = res.data.rows;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
  filters: {
    operateTypeFilter(val){
      if (!val) return '--'
      if(val == 1){
        return '商城退货'
      }else if(val == 2){
        return '商城退货'
      }else if(val == 3){
        return '确认收货'
      }else if(val == 4){
        return '销售消耗'
      }else if(val == 5){
        return '销售退货'
      }else if(val == 6){
        return '服务消耗'
      }else if(val == 7){
        return '公共套盒申请'
      }else if(val == 8){
        return '转成公共套盒'
      }else if(val == 9){
        return '库存盘点'
      }else if(val == 10){
        return '库存调整'
      }else if(val == 11){
        return '套盒拆分'
      }else if(val == 12){
        return '商品入库'
      }
    },
    stockTypeFilter(val){
      if (!val) return '--'
      if(val == 1){
        return '现有库存'
      }else if(val == 2){
        return '寄存库存'
      }else if(val == 3){
        return '公共库存'
      }else if(val == 4){
        return '可用库存'
      }else if(val == 5){
        return '订单库存'
      }
    }
  }
};
</script>
<style lang="less" scoped>
.recordList {
  padding: 0 20px 10px;
  .searchBtn {
    width: 47px;
    height: 38px;
    background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
      no-repeat center;
  }
  .tit {
    color: #666;
    text-align: right;
    padding-right: 20px;
    margin-bottom: 20px;
  }
  .myMemTable {
    // border: 1px solid #d5d9e3;
    .tableGoods {
      .myTitle {
        width: 100%;
        max-height: 40px;
        line-height: 20px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .btnOptions {
    margin: 40px 0 0 0;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/recordData.vue